
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { PcgEmissionSource, PcgSource } from "src/store/pcg/types";
import { getAllPcgAPI,GetPcgByIdAPI,postRegisterPcgAPI,putUpdatePcgAPI,postResgisterPcgEmissionsAPI,deletePcgEmissionsAPI,getPcgEmissionsAPI
    } from "src/services/restcall";

    
export const getAllPcg = (): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllPcgAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const GetPcgById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetPcgByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postRegisterPcg = (value:PcgSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postRegisterPcgAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Pcg "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putUpdatePcg = (value:PcgSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putUpdatePcgAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Pcg "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getPcgEmissions = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPcgEmissionsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postResgisterPcgEmissions = (value:PcgEmissionSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postResgisterPcgEmissionsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","PCG "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const deletePcgEmissions = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deletePcgEmissionsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false)); 
        openNotification("Eliminación","PCG "+validateMessages.deleteSuccess);        
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

